<div class="lm-simple-progress" [attr.title]="title">
  @if (width > 0) {
    <div class="{{colorClass}}" [style.width.%]="width"></div>
  }
  <div class="lm-range-text {{inverseClass}}">{{displayValue}}</div>
</div>